module.exports = __webpack_public_path__ + "img/slider4.12328fbe.jpg";